<template>
      <div id="appointmentTypeForm" class="form">
        <v-form v-if="loaded" ref="form" v-model="valid" lazy-validation>
          <v-text-field
              v-model="appointmentType.label"
              label="Label"
              :required="true"
            />
            <v-text-field
              v-model="appointmentType.description"
              label="Description"
              :required="false"
            />
            <v-text-field
              v-model="appointmentType.color"
              label="Color"
              :required="false"
            />
            
        <div class="mt-4 d-flex justify-space-between">
        <v-btn @click="goBack">
          Back
        </v-btn>
        <v-btn @click="handleSubmit" color="primary">
          {{ id ? "Update" : "Save" }}
        </v-btn>
        <span></span>
      </div>
        </v-form>
      </div>
    </template>
    
<script>
  import { getAppointmentType } from "@/services/appointmentType";
  
  
  import { mapActions } from "vuex";

  

  export default {
    props: ["id"],
    data () {
      return {
        loaded: false,
        valid: false,
        appointmentType: {
          relations: {
            
          },
          label: '',
description: '',
color: '',

        }
      }
    },
    created() {
      this.setInstace();
    },
    methods: {
      ...mapActions("appointmentType", ["createAppointmentType", "updateAppointmentType"]),
      ...mapActions("messages", [
        "addMessage",
        "addErrorMessage",
        "addSuccessMessage"
      ]),
      
      async handleSubmit() {
        if (this.id) {
          let appointmentType = this.appointmentType;
          delete appointmentType.relations;

          this.updateAppointmentType(appointmentType)
          .then( (response) => {
            console.log(response);
            this.addSuccessMessage("AppointmentType was updated successfully");
            this.goBack();
          }).catch( () => {
            this.addErrorMessage("Error updating AppointmentType, please try again later");
          });
        } else {
          let appointmentType = this.appointmentType;
          delete appointmentType.relations;

          this.createAppointmentType(appointmentType)
          .then( response => {
            console.log(response);
            this.addSuccessMessage("AppointmentType was created successfully");
            this.goBack();
          }).catch( () => {
            this.addErrorMessage("Error creating AppointmentType, please try again later");
          })
        }
      },
      goBack() {
        this.$router.go(-1);
      },
      setInstace() {
        if (this.id) {
          this.appointmentType.id = this.id;
          getAppointmentType(this.id)
            .then(response => {
              let instance = response.data;
              for (let property in instance) {
                if (Object.prototype.hasOwnProperty.call(instance, property) && Object.prototype.hasOwnProperty.call(this.appointmentType, property)) {
                  this.appointmentType[property] = instance[property];
                }
              }
              this.loaded = true;
            })
        } else {
          this.loaded = true;
        }
        this.setDependencies();
      },
      setDependencies() {
        
      }
    },
    components: {
      
    }
  }
</script>
